/* tslint:disable */
/* eslint-disable */
/**
 * EFood Storefront API
 * This is the EFood Storefront API specification.  Operations are grouped by tags.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 * @enum {string}
 */

export const HistoricalOrderStatusFilter = {
    Exported: 'EXPORTED',
    Awaitingapproval: 'AWAITINGAPPROVAL',
    Approved: 'APPROVED',
    Processing: 'PROCESSING',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Completed: 'COMPLETED',
    Rejected: 'REJECTED',
    Partiallyapproved: 'PARTIALLYAPPROVED',
    Partiallyshipped: 'PARTIALLYSHIPPED',
    Partiallydelivered: 'PARTIALLYDELIVERED'
} as const;

export type HistoricalOrderStatusFilter = typeof HistoricalOrderStatusFilter[keyof typeof HistoricalOrderStatusFilter];



